import { render, staticRenderFns } from "./_manageParticipants.vue?vue&type=template&id=1f5b58c8"
import script from "./_manageParticipants.vue?vue&type=script&lang=js"
export * from "./_manageParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports